import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useRealtimeRace } from '../../hooks/useRealtime'
import { TimerOverlay } from '../../components/overlay/TimerOverlay'

export function TimerPage() {
  const [searchParams] = useSearchParams()
  const raceId = searchParams.get('race') || ''
  const [elapsed, setElapsed] = useState(0)

  const { race } = useRealtimeRace(raceId)

  useEffect(() => {
    const interval = setInterval(() => {
      setElapsed((prev) => prev + 10)
    }, 10)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="w-full h-screen bg-transparent">
      <TimerOverlay
        elapsed={elapsed}
        isActive={race?.status === 'active' || false}
      />
    </div>
  )
}
